<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent scrollable max-width="1200px">
      <v-card>
        <div class="dialog-header">
          <div class="popup-title">
            {{
              meeting && meeting.isLMSMeeting
                ? $t('page.meeting-control.lms-control')
                : $t('page.meeting-control.meeting-control')
            }}
            (PC/Mobile)
          </div>

          <button
            @click="refreshAll"
            class="onlyIconButton ico_search"
            style="margin-right: 20px"
          >
            <img
              src="/static/icon-contents/reload1.svg"
              style="width: 16px; height: 16px"
            />
          </button>
        </div>
        <v-card>
          <v-card-text style="padding: 0 24px">
            <v-flex xs12 md12 v-if="meeting !== null">
              <v-container fluid grid-list-xl>
                <v-layout row wrap style="display: flex">
                  <div class="control-contents-wrap">
                    <div class="control-contents-row">
                      <span>회의명 : {{ meeting.title }}</span>
                    </div>
                    <div class="control-contents-row">
                      <span>회의 시간 :</span>
                      <span>
                        {{ meeting.startDtime | formatDate2 }} /
                        {{ meeting.startDtime | formatTime }} ~
                        {{ meeting.endDtime | formatTime }}
                      </span>
                    </div>
                    <div class="control-contents-row">
                      <span>비밀번호 :</span>
                      <span>{{
                        meeting.isPrivate ? `설정됨` : `설정되지 않음`
                      }}</span>
                    </div>
                    <div class="control-contents-row">
                      <span>참여현황 :</span>
                      <span>
                        {{
                          `참여 ${
                            attendeeList.filter((a) => a.status).length
                          } / 미참여 ${
                            attendeeList.filter((a) => !a.status).length
                          }`
                        }}
                      </span>
                    </div>

                    <div class="control-contents-row">
                      <span>회의유형 :</span>
                      <span>{{ meeting.callId ? `HW전용` : `PC&모바일` }}</span>
                    </div>
                    <!-- <div>{{ (meeting.type === 'video' ? $t('page.statistics.all-status.video') : $t('page.statistics.all-status.room')) }}</div> -->
                    <div class="control-contents-row">
                      <span>주재자 :</span>
                      <span>{{
                        meeting.creator.username
                          ? `${meeting.creator.username} (${
                              meeting.creator.deptName
                                ? meeting.creator.deptName
                                : '-'
                            })`
                          : ``
                      }}</span>
                    </div>
                    <div class="control-contents-row">
                      <span>부가기능 :</span>
                      <span>{{ meeting.sttLog ? '실시간 번역' : '없음' }}</span>
                    </div>
                  </div>
                </v-layout>
              </v-container>
            </v-flex>
          </v-card-text>
        </v-card>

        <v-card-actions id="meetingControl">
          <!-- <div class="meeting-control-btn kb_bg" @click="muteAll">
            {{ `전체 음소거` }}
          </div> -->
          <!-- <div
            class="meeting-control-btn"
            style="font-size: 14px; background: red"
            v-if="!isManager"
            @click="finishMeeting"
          >
            {{ `회의 종료` }}
          </div> -->
        </v-card-actions>
        <v-card-text>
          <v-card id="controlWrap">
            <v-data-table
              :headers="getHeaders()"
              :items="attendeeList"
              :loading="loading"
              :rows-per-page-items="[8, 10, 20, 50]"
            >
              <template v-slot:headers="props">
                <tr style="height: 45px !important">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['header-text-popup', 'column']"
                    :style="header.width ? 'width:' + header.width + ';' : ''"
                  >
                    <!-- <v-icon small>arrow_upward</v-icon> -->
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  {{
                    props.item.type === 'pc'
                      ? 'PC'
                      : props.item.type === 'mobile'
                      ? '모바일'
                      : props.item.type === 'codec'
                      ? '화상기기'
                      : '-'
                  }}
                </td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">
                  <div class="state-btn">
                    {{ props.item.status === true ? '참여' : '미참여' }}
                  </div>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      loading = true;
                      props.item['connLoading'] = true;
                      changeAudioStatus(
                        meetingInfo.meetingKey,
                        props.item.userId,
                        props.item.rxAudioMute,
                        props.item,
                      );
                    "
                    :disabled="props.item.status ? false : true"
                  >
                    {{
                      !props.item.rxAudioMute
                        ? 'mdi-microphone'
                        : 'mdi-microphone-off'
                    }}
                  </v-icon>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      loading = true;
                      props.item['connLoading'] = true;
                      changeVideoStatus(
                        meetingInfo.meetingKey,
                        props.item.userId,
                        props.item.rxVideoMute,
                        props.item,
                      );
                    "
                    :disabled="props.item.status ? false : true"
                  >
                    {{
                      !props.item.rxVideoMute ? 'mdi-video' : 'mdi-video-off'
                    }}
                  </v-icon>
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      // loading = true;
                      // props.item['connLoading'] = true;
                      connectUser(
                        props.item.remoteParty,
                        props.item.name,
                        props.item,
                      )
                    "
                    :disabled="
                      props.item.status || props.item.connLoading ? true : false
                    "
                    >mdi-login</v-icon
                  >
                </td>
                <td class="text-xs-center">
                  <v-icon
                    color="primary"
                    @click="
                      if (props.item.type === 'codec') {
                        disConnectCodec(props.item.callLegId);
                      } else {
                        disConnectUser(
                          meetingInfo.meetingKey,
                          props.item.userId,
                        );
                      }
                    "
                    :disabled="props.item.status ? false : true"
                    >mdi-logout</v-icon
                  >
                </td>
              </template>
            </v-data-table>
          </v-card>
          <div class="control-addBtn">
            <!-- <button class="opt-btn kb_bg" @click="openUserInvitationDialog">
              + 사용자 초대
            </button> -->
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
        <div class="btnArea">
          <button class="btnPrimary" @click="popupClose">닫기</button>
        </div>
      </v-card>
    </v-dialog>
    <loading-dialog
      :dialog="loadingDialog.dialog"
      :content="loadingDialog.content"
    />
    <warning-dialog
      :title="warning.title"
      :content="warning.content"
      :confirmText="warning.confirmText"
      :dialog="warning.dialog"
      :closeDialog="closeWarningDialog"
      :message="warning.errorMsg"
    />
    <meeting-additional-invite-dialog
      :dialog="addRoom.dialog"
      :meetingInfo="meeting ? meeting : {}"
      :roomItems="addRoom.roomItems"
      :roomSave="roomSave"
      :organizationItems="addAttendee.organizationItems"
      :people="addAttendee.people"
      :closeDialog="closeRoomDialog"
    />
    <meeting-attendee-detail-dialog
      :dialog="attendeeDetail.dialog"
      :attendeeInfo="attendeeDetail.attendeeInfo"
      :attendeeDetailInfo="attendeeDetail.attendeeDetailInfo"
      :refreshDetailData="refreshDetailData"
      :layoutList="layoutList"
      :layoutChange="layoutChange"
      :closeDialog="closeDetailDialog"
    />
    <!-- <organization-chart-dialog
      :dialog="organizationChartDialog.dialog"
      :meetingId="organizationChartDialog.meetingId"
      :selectedAttendees="[]"
      :closeDialog="closeUserInvitationDialog"
      @attendeeSave="attendeeSave"
    /> -->
  </v-layout>
</template>
<script>
import Util from '@/util';
import WarningDialog from '@/components/popup/WarningDialog';
import LoadingDialog from '@/components/popup/LoadingDialog';
import MeetingAdditionalInviteDialog from '@/components/popup/MeetingAdditionalInviteDialog';
import MeetingAttendeeDetailDialog from '@/components/popup/MeetingAttendeeDetailDialog';
import OrganizationChartDialog from '@/components/popup/organizationChartDialog';

import API from '@/api';

export default {
  components: {
    LoadingDialog,
    WarningDialog,
    MeetingAdditionalInviteDialog,
    MeetingAttendeeDetailDialog,
    OrganizationChartDialog,
  },
  props: ['meeting', 'dialog', 'closeDialog', 'isManager'],
  data() {
    return {
      meetingInfo: {},
      attendeeList: [],
      deviceList: [],
      messageText: '',
      selectedMessageTime: 'permanent',
      isRecording: false,
      isStreaming: false,
      layoutAll: API.layoutList[0],
      loading: false,
      loadingDialog: {
        dialog: false,
        content: '',
      },
      /*
       * 경고 Dialog
       */
      warning: {
        title: '',
        content: '',
        confirmText: '',
        type: '',
        dialog: false,
        errorMsg: null,
      },
      /*
       * 추가 초대 Dialog
       */
      addInvite: {
        dialog: false,
      },
      /*
       * 회의실 추가 초대 Dialog
       */
      addRoom: {
        dialog: false,
        roomItems: [],
        personalItems: [],
      },
      /*
       * 개인 단말 추가 초대 Dialog
       */
      addAttendee: {
        dialog: false,
        organizationItems: [],
        people: [],
      },
      /*
       * 추가 초대 Dialog
       */
      organizationChartDialog: {
        dialog: false,
        selectedAttendees: [], // 조직도 Dialog Open 시 이미 선택된 리스트 바인딩을 위한 값.
      },
      /*
       * 참여자 상세정보 Dialog
       */
      attendeeDetail: {
        dialog: false,
        attendeeInfo: {},
        attendeeDetailInfo: null,
      },
      layoutList: API.layoutList,
      /*
       * 레이아웃 고정 Dialog
       */
      fixLayout: {
        dialog: false,
      },
      call: null,
    };
  },
  computed: {
    computePageHeaderIcon() {
      return '/static/page_header.png';
    },
  },
  watch: {
    async dialog(val) {
      if (!val) return;
      this.meetingInfo = this.meeting;
      this.attendeeList = [];
      this.loadingDialog.dialog = true;
      // 참여자 정보 가져오기
      this.initAttendees(this.meetingInfo);
      await this.getNowStatus(this.meetingInfo.meetingKey);
      // await this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id);
    },
  },
  methods: {
    // openUserInvitationDialog() {
    //   console.log('openUserInvitationDialog called..');
    //   this.organizationChartDialog.dialog = true;
    // },
    // async closeUserInvitationDialog() {
    //   console.log('closeUserInvitationDialog called..');
    //   this.organizationChartDialog.dialog = false;
    // },
    // async attendeeSave(selectedAttendees) {
    //   console.log(`attendeeSave called.. `, { selectedAttendees });
    //   let params = {
    //     attendees: selectedAttendees,
    //   };

    //   try {
    //     let response = (
    //       await this.$http.put(
    //         `/api/v1/meetings/${this.meetingInfo._id}/attendees`,
    //         params
    //       )
    //     ).data;
    //     console.log('attendeeSave called.. ', { response });

    //     this.meetingInfo = response;

    //     this.initAttendees(this.meetingInfo);
    //     await this.getNowStatus(this.meetingInfo.meetingKey);

    //     this.organizationChartDialog.dialog = false;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    getHeaders() {
      return [
        {
          text: '참여유형',
          value: 'type',
          align: 'center',
          width: '140px',
          sortable: false,
          class: 'header-text-popup',
        },
        // { text: this.$t('page.meeting-control.attendee-list.participant-type'), value: 'participantType', align: 'center', width: '150px', sortable: false, class: 'header-text-popup' },
        // { text: this.$t('page.meeting-control.attendee-list.invited'), value: 'invited', width: '110px', align: 'center', sortable: false, class: 'header-text-popup' },
        {
          text: '참여자',
          value: 'name',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '상태',
          width: '120px',
          value: 'status',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        // { text: this.$t('page.meeting-control.attendee-list.ip'), value: 'ip', width: '160px', align: 'center', sortable: false, class: 'header-text-popup' },
        {
          text: '마이크',
          value: 'rxAudioMute',
          width: '100px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '카메라',
          value: 'rxVideoMute',
          width: '100px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '연결',
          value: 'connection',
          width: '70px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        {
          text: '끊기',
          value: 'hangUp',
          width: '100px',
          align: 'center',
          sortable: false,
          class: 'header-text-popup',
        },
        // {
        //   text: '문서공유',
        //   value: 'share',
        //   width: '70px',
        //   align: 'center',
        //   sortable: false,
        //   class: 'header-text-popup',
        // },
        // {
        //   text: '레이아웃',
        //   value: 'layout',
        //   width: '220px',
        //   align: 'center',
        //   sortable: false,
        //   class: 'header-text-popup',
        // },
        // { text: this.$t('page.meeting-control.attendee-list.layout'), value: 'layout', width: '80px', align: 'center', sortable: false, class: 'header-text-popup' },
        // {
        //   text: '세부정보',
        //   value: 'detail',
        //   width: '70px',
        //   align: 'center',
        //   sortable: false,
        //   class: 'header-text-popup',
        // },
      ];
    },
    initAttendees(meeting) {
      this.attendeeList = meeting.attendees.map((item) => {
        return {
          type: '-',
          invited: true,
          userId: item.empNum,
          name: `${item.name}${item.title ? `/${item.title}` : ''}${
            item.companyName ? `/${item.companyName}` : ''
          }`, // item.displayFullName,
          // name: item.displayFullName,
          remoteParty: item.empNum ? item.empNum : item.email,
          status: false,
          callLegId: null,
        };
      });
    },
    async getControlDevice(meetingId) {
      await this.$http
        .get('/api/v1/meetings/getControlDevice', {
          params: { _id: meetingId },
        })
        .then((response) => {
          let deviceData = response.data.map((item) => {
            return {
              type: 'codec',
              invited: true,
              name: item.deviceName,
              remoteParty: item.uri,
              status: false,
              callLegId: null,
            };
          });
          this.attendeeList = this.attendeeList.concat(deviceData);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCoSpaceInfo(callId, meetingId) {
      await this.$http
        .get('/api/v1/meetings/getCoSpaceInfo', {
          params: { callId: callId, meetingId: meetingId },
        })
        .then((response) => {
          let coSpaceInfo = response.data.coSpace;
          console.log(`coSpaceInfo`, coSpaceInfo);
          if (coSpaceInfo && coSpaceInfo.defaultLayout) {
            this.layoutAll = coSpaceInfo.defaultLayout;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCallStatus(callId, meetingId) {
      await this.$http
        .get('/api/v1/meetings/getCallStatus', {
          params: { callId: callId, meetingId: meetingId },
        })
        .then((response) => {
          this.call = response.data;
          console.log(`this.call.call`, this.call.call);
          this.isRecording =
            this.call.call.recording === 'true' ||
            this.call.call.recording === true
              ? true
              : false;
          this.isStreaming =
            this.call.call.streaming === 'true' ||
            this.call.call.streaming === true
              ? true
              : false;
          console.log(
            `isRecording/ isStreaming`,
            this.isRecording,
            this.isStreaming,
          );
          console.log(this.call);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStatusFromCd(statusCd) {
      // 마이크 상태값 셋팅
      if (statusCd === 1) {
        // ON
        return false;
      } else if (statusCd === 2) {
        // OFF
        return true;
      } else {
        return false;
      }
    },
    async getNowStatus(meetingKey) {
      try {
        // backend 쪽으로 새하 참석자 목록을 가져오는 API 호출
        let response = await this.$http.get(
          '/api/v1/meetings/pcmobile/participants',
          {
            params: { meetingKey: meetingKey, isMCU: false },
          },
        );
        console.log('getNowStatus called..', { response });
        // 사용자 정보 매핑
        if (!response.data.data) {
          this.loadingDialog.dialog = false;
          return;
        }
        let participants = response.data.data.content;
        participants.forEach((item) => {
          const index = this.attendeeList.findIndex(
            (elem) => elem.userId === item.userId,
          );
          // 초대자
          if (index >= 0) {
            // 참여자 셋팅
            this.attendeeList[index]['name'] = item.userName;

            // 참여유형 셋팅
            if ([3, 4, 5, 6].includes(item.clientType)) {
              this.attendeeList[index]['type'] = 'mobile';
            } else if (item.clientType === 11) {
              this.attendeeList[index]['type'] = 'codec';
            } else {
              this.attendeeList[index]['type'] = 'pc';
            }

            // 상태 셋팅
            this.attendeeList[index]['status'] = true;

            // 마이크 상태값 셋팅
            this.attendeeList[index]['rxAudioMute'] = this.getStatusFromCd(
              item.micStatusCd,
            );
            // 카메라 상태값 셋팅
            this.attendeeList[index]['rxVideoMute'] = this.getStatusFromCd(
              item.camStatusCd,
            );

            // if (item.micStatusCd === 1) {
            //   // ON
            //   this.attendeeList[index]['rxAudioMute'] = false;
            // } else if (item.micStatusCd === 2) {
            //   // OFF
            //   this.attendeeList[index]['rxAudioMute'] = true;
            // } else {
            //   this.attendeeList[index]['rxAudioMute'] = false;
            // }

            // if (item.camStatusCd === 1) {
            //   // ON
            //   this.attendeeList[index]['rxVideoMute'] = false;
            // } else if (item.camStatusCd === 2) {
            //   // OFF
            //   this.attendeeList[index]['rxVideoMute'] = true;
            // } else {
            //   // NONE
            //   this.attendeeList[index]['rxVideoMute'] = false;
            // }

            this.attendeeList[index]['meetCode'] = item.meetCode;
            this.attendeeList[index]['roomCode'] = item.roomCode;
            this.attendeeList[index]['presentationContributionAllowed'] =
              item.presentationContributionAllowed;
            this.attendeeList[index]['chosenLayout'] = item.chosenLayout
              ? item.chosenLayout
              : this.layoutAll;
            // this.attendeeList[index]['type'] = item.participantType;
          } else {
            // 비 초대자
            // 참여자 셋팅
            let type = '-';
            // 참여유형 셋팅
            if ([3, 4, 5, 6].includes(item.clientType)) {
              type = 'mobile';
            } else if (item.clientType === 11) {
              type = 'codec';
            } else {
              type = 'pc';
            }

            this.attendeeList.push({
              type: type,
              invited: false,
              name: item.userName,
              status: true,
              participantType: item.participantType,
              rxAudioMute: this.getStatusFromCd(item.micStatusCd),
              rxVideoMute: this.getStatusFromCd(item.camStatusCd),
              presentationContributionAllowed:
                item.presentationContributionAllowed,
              chosenLayout: item.chosenLayout
                ? item.chosenLayout
                : this.layoutAll,
            });
          }
        });

        if (this.meetingInfo.isCospaceInBodaRoom === true) {
          await this.getNowStatusFromCMS(this.meetingInfo.callId);
        }

        this.loadingDialog.dialog = false;
        this.attendeeListSort();
      } catch (error) {
        console.log(error);
        this.loadingDialog.dialog = false;
      }

      /*
        .catch((error) => {
          console.log(error);
          this.loadingDialog.dialog = false;
        });
        */

      // CMS 참석자 조회

      // await this.$http
      //   .get('/api/v1/meetings/getNowStatus', { params: { callId: callId } })
      //   .then((response) => {
      //     // 데이터 매핑하기
      //     if (response.data.callLegs === undefined) {
      //       this.attendeeListSort();
      //       this.loadingDialog.dialog = false;
      //       return;
      //     }
      //     if (Number(response.data.callLegs.$.total) >= 1) {
      //       let callLegs = [];
      //       if (!Array.isArray(response.data.callLegs.callLeg)) {
      //         callLegs.push(response.data.callLegs.callLeg);
      //       } else {
      //         callLegs = response.data.callLegs.callLeg;
      //       }
      //       callLegs.forEach((item) => {
      //         const index = this.attendeeList.findIndex(
      //           (elem) =>
      //             elem.remoteParty === item.remoteParty ||
      //             elem.remoteParty === item.remoteParty.split('@')[0]
      //         );
      //         // 초대자
      //         if (index >= 0) {
      //           this.attendeeList[index]['callLegId'] = item.$.id;
      //           this.attendeeList[index]['status'] = true;
      //           if (item.participantType === 'webex') {
      //             this.attendeeList[index].type = 'webex';
      //           }
      //           this.attendeeList[index]['participantType'] =
      //             item.participantType;
      //           this.attendeeList[index]['rxAudioMute'] = item.rxAudioMute;
      //           this.attendeeList[index]['rxVideoMute'] = item.rxVideoMute;
      //           this.attendeeList[index]['serverIdx'] = item.serverIdx;
      //           this.attendeeList[index]['presentationContributionAllowed'] =
      //             item.presentationContributionAllowed;
      //           this.attendeeList[index]['chosenLayout'] = item.chosenLayout
      //             ? item.chosenLayout
      //             : this.layoutAll;
      //           this.attendeeList[index]['type'] = item.participantType;
      //         } else {
      //           let checkName = item.name ? item.name : item.remoteParty;
      //           if (!['streaming', 'recording'].includes(checkName)) {
      //             // 비 초대자
      //             let type = 'person';
      //             if (
      //               (item.remoteParty.split('@').length >= 1 &&
      //                 Util.validationIpAddress(
      //                   item.remoteParty.split('@')[1]
      //                 ) === true) ||
      //               item.participantType === 'codec'
      //             ) {
      //               type = 'codec';
      //             }
      //             this.attendeeList.push({
      //               type: item.participantType,
      //               invited: false,
      //               name: item.name ? item.name : item.remoteParty,
      //               remoteParty: item.remoteParty,
      //               status: true,
      //               callLegId: item.$.id,
      //               participantType: item.participantType,
      //               rxAudioMute: item.rxAudioMute,
      //               rxVideoMute: item.rxVideoMute,
      //               serverIdx: item.serverIdx,
      //               presentationContributionAllowed:
      //                 item.presentationContributionAllowed,
      //               chosenLayout: item.chosenLayout
      //                 ? item.chosenLayout
      //                 : this.layoutAll,
      //             });
      //           }
      //         }
      //       });
      //     }

      //     this.attendeeListSort();
      //     // 초대 안된 사람도 추가
      //     this.loadingDialog.dialog = false;
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     this.loadingDialog.dialog = false;
      //   });
    },
    async getNowStatusFromCMS(callId) {
      try {
        let response = await this.$http.get('/api/v1/meetings/getNowStatus', {
          params: { callId: callId },
        });

        // 데이터 매핑하기
        if (response.data.callLegs === undefined) {
          this.attendeeListSort();
          this.loadingDialog.dialog = false;
          return;
        }
        if (Number(response.data.callLegs.$.total) >= 1) {
          let callLegs = [];
          if (!Array.isArray(response.data.callLegs.callLeg)) {
            callLegs.push(response.data.callLegs.callLeg);
          } else {
            callLegs = response.data.callLegs.callLeg;
          }
          callLegs.forEach((item) => {
            if (item.participantType === 'codec') {
              const index = this.attendeeList.findIndex(
                (elem) =>
                  elem.remoteParty === item.remoteParty ||
                  elem.remoteParty === item.remoteParty.split('@')[0],
              );
              // 초대자
              if (index >= 0) {
                this.attendeeList[index]['callLegId'] = item.$.id;
                this.attendeeList[index]['status'] = true;
                if (item.participantType === 'webex') {
                  this.attendeeList[index].type = 'webex';
                }
                this.attendeeList[index]['participantType'] =
                  item.participantType;
                this.attendeeList[index]['rxAudioMute'] = item.rxAudioMute;
                this.attendeeList[index]['rxVideoMute'] = item.rxVideoMute;
                this.attendeeList[index]['serverIdx'] = item.serverIdx;
                this.attendeeList[index]['presentationContributionAllowed'] =
                  item.presentationContributionAllowed;
                this.attendeeList[index]['chosenLayout'] = item.chosenLayout
                  ? item.chosenLayout
                  : this.layoutAll;
                this.attendeeList[index]['type'] = item.participantType;
              } else {
                let checkName = item.name ? item.name : item.remoteParty;
                if (!['streaming', 'recording'].includes(checkName)) {
                  // 비 초대자
                  let type = 'person';
                  if (
                    (item.remoteParty.split('@').length >= 1 &&
                      Util.validationIpAddress(
                        item.remoteParty.split('@')[1],
                      ) === true) ||
                    item.participantType === 'codec'
                  ) {
                    type = 'codec';
                  }
                  this.attendeeList.push({
                    type: item.participantType,
                    invited: false,
                    name: item.name ? item.name : item.remoteParty,
                    remoteParty: item.remoteParty,
                    status: true,
                    callLegId: item.$.id,
                    participantType: item.participantType,
                    rxAudioMute: item.rxAudioMute,
                    rxVideoMute: item.rxVideoMute,
                    serverIdx: item.serverIdx,
                    presentationContributionAllowed:
                      item.presentationContributionAllowed,
                    chosenLayout: item.chosenLayout
                      ? item.chosenLayout
                      : this.layoutAll,
                  });
                }
              }
            } else {
              const index = this.attendeeList.findIndex(
                (elem) =>
                  elem.remoteParty === item.remoteParty ||
                  elem.remoteParty === item.remoteParty.split('@')[0],
              );
              // 초대자
              if (index >= 0) {
                this.attendeeList[index]['callLegId'] = item.$.id;
                this.attendeeList[index]['chosenLayout'] = item.chosenLayout
                  ? item.chosenLayout
                  : this.layoutAll;
              }
            }
          });
        }

        console.log('getNowStatus called..', {
          response,
          attendeeList: this.attendeeList,
        });
      } catch (error) {
        console.log(error);
        this.loadingDialog.dialog = false;
      }
    },
    async attendeeListSort() {
      // !!this.attendeeList Sort!! ( 정렬 순서 변경 필요할 수 있음 )
      console.log(`attendeeListSort Start`);
      this.attendeeList.sort((a, b) => {
        let o1 = String(a.type).toLowerCase();
        let o2 = String(b.type).toLowerCase();

        let p1 = String(a.status).toLowerCase();
        let p2 = String(b.status).toLowerCase();

        if (p1 < p2) return 1;
        if (p1 > p2) return -1;
        if (o1 < o2) return 1;
        if (o1 > o2) return -1;

        return 0;
      });
    },

    async updateCodecStatus(callLegId, type) {
      return new Promise(async (resolve, reject) => {
        /**
         * @type Audio Mute, Unmute - { "rxAudioMute": true, false }
         * @type Video Mute, Unmute - { "rxVideoMute": true, false }
         * @type Set Layout - { "chosenLayout": layoutList selected value }
         */

        console.log('updateUserStatus called..', { type });
        await this.$http
          .post(`/api/v1/meetings/updateUserStatus/${callLegId}`, type)
          .then((response) => {
            console.log(response);
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            resolve(false);
          });
      });
    },

    async updateCallLegIdStatus(callLegId, remoteParty, serverIdx) {
      // await setTimeout(async () => {
      return new Promise(async (resolve, reject) => {
        await this.$http
          .get(`/api/v1/meetings/getNowStatusDetail/${callLegId}`, {
            params: { serverIdx: serverIdx, callId: this.meetingInfo.callId },
          })
          .then((responseStatus) => {
            let index = this.attendeeList.findIndex(
              (item) => item.remoteParty === remoteParty,
            );
            if (responseStatus.data) {
              if (
                index >= 0 &&
                (responseStatus.data.callLeg.status.state === 'connected' ||
                  (responseStatus.data.callLeg.status.state === 'initial' &&
                    remoteParty.split('@').length >= 1 &&
                    remoteParty.split('@')[1] === 'doosandi.webex.com'))
              ) {
                this.attendeeList[index].callLegId = callLegId;
                this.attendeeList[index].status = true;
                let confData = responseStatus.data.callLeg.configuration;
                this.attendeeList[index]['serverIdx'] = serverIdx;
                this.attendeeList[index]['rxAudioMute'] =
                  confData.rxAudioMute === 'true' ? true : false;
                this.attendeeList[index]['rxVideoMute'] =
                  confData.rxVideoMute === 'true' ? true : false;
                this.attendeeList[index]['presentationContributionAllowed'] =
                  confData.presentationContributionAllowed === 'true'
                    ? true
                    : false;
              }
            }
            // Loading 상태 변경
            if (index >= 0) {
              this.attendeeList[index]['connLoading'] = false;
            }
            this.loading = false;
            resolve(true);
          })
          .catch((error) => {
            console.log(error);
            this.loadingDialog.dialog = false;
            this.loading = false;
            resolve(false);
          });
      });
      // }, 2000);
    },
    async updateUserStatus(meetingKey, userId, type, value) {
      let params = {
        meetingKey,
        userId,
        type,
        value,
        isMCU: false,
      };
      await this.$http
        .post(`/api/v1/meetings/pcmobile/participants/control/`, params)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // async updateUserStatus(callLegId, type) {
    //   /**
    //    * @type Audio Mute, Unmute - { "rxAudioMute": true, false }
    //    * @type Video Mute, Unmute - { "rxVideoMute": true, false }
    //    * @type Set Layout - { "chosenLayout": layoutList selected value }
    //    */
    //   await this.$http
    //     .put(`/api/v1/meetings/updateUserStatus/${callLegId}`, type)
    //     .then((response) => {
    //       console.log(response);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    async updateUserStatusAll(type) {
      /**
       * @type Audio Mute, Unmute - { "rxAudioMute": true, false }
       * @type Video Mute, Unmute - { "rxVideoMute": true, false }
       * @type Set Layout - { "layout": layoutList selected value }
       */
      let callId = this.meetingInfo.callId;
      if (callId === '' && this.meetingInfo.callId2 !== '') {
        callId = this.meetingInfo.callId2;
      } else if (callId === '' && this.meetingInfo.callId3 !== '') {
        callId = this.meetingInfo.callId3;
      }
      await this.$http
        .post(`/api/v1/meetings/updateUserStatusAll/${callId}`, type)
        .then((response) => {
          // console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async changeAudioStatus(meetingKey, userId, rxAudioMute, item) {
      // TODO - CMS 장비인 경우 CMS API 호출
      console.log('changeAudioStatus called..', {
        meetingKey,
        userId,
        rxAudioMute,
      });
      console.log(`item`, item);
      let type = 2; // (CAM: 1, MIC: 2, SPK: 3)
      let value = rxAudioMute ? 1 : 0; // (STOP: 0, START: 1)

      if (
        this.meetingInfo.isCospaceInBodaRoom === true &&
        item.type === 'codec' &&
        item.callLegId
      ) {
        // 코덱인 경우
        await this.updateCodecStatus(item.callLegId, {
          rxAudioMute: !rxAudioMute,
          callId: this.meetingInfo.callId,
        });

        await this.updateCallLegIdStatus(item.callLegId, item.remoteParty);
        // this.loadingDialog.dialog = false;
      } else {
        // PC Mobile 인 경우
        await this.updateUserStatus(meetingKey, userId, type, value);
        await this.refreshUserStatus(meetingKey, userId);
      }
    },
    async changeVideoStatus(meetingKey, userId, rxVideoMute, item) {
      console.log(meetingKey);
      console.log(`userId :::::: `, userId);
      // TODO - CMS 장비인 경우 CMS API 호출
      console.log('changeVideoStatus called..', {
        meetingKey,
        userId,
        rxVideoMute,
      });
      let type = 1; // (CAM: 1, MIC: 2, SPK: 3)
      let value = rxVideoMute ? 1 : 0; // (STOP: 0, START: 1)

      if (
        this.meetingInfo.isCospaceInBodaRoom === true &&
        item.type === 'codec' &&
        item.callLegId
      ) {
        // 코덱인 경우
        await this.updateCodecStatus(item.callLegId, {
          rxVideoMute: !rxVideoMute,
          callId: this.meetingInfo.callId,
        });
        await this.updateCallLegIdStatus(item.callLegId, item.remoteParty);
        // this.loadingDialog.dialog = false;
      } else {
        // PC Mobile 인 경우
        await this.updateUserStatus(meetingKey, userId, type, value);
        await this.refreshUserStatus(meetingKey, userId);
      }
    },
    async terminateShareMode() {
      let meetingKey = this.meetingInfo.meetingKey;
      let params = {
        meetingKey,
      };
      await this.$http
        .post(`/api/v1/meetings/pcmobile/share/mode`, params)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async connectUser(remoteParty, name, item) {
      // 사용자 이면, 연결은 불가능 하기 때문에 alert누르고, 쪽지 발송 API 호출
      alert('선택한 사용자에게 미팅 참여 안내 쪽지가 발송 됩니다.');
      console.log(`connectUser Info`, item);
      await this.$http
        .post(`/api/v1/meetings/send/join/message`, {
          meetingId: this.meetingInfo._id,
          empNum: item.userId,
        })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
      return;
    },
    async refreshUserStatus(meetingKey, userId) {
      console.log(`userId`, userId);
      await setTimeout(async () => {
        try {
          let responseStatus = (
            await this.$http.get(
              `/api/v1/meetings/pcmobile/participants/${userId}`,
              {
                params: { meetingKey, isMCU: false },
              },
            )
          ).data;

          let index = this.attendeeList.findIndex(
            (item) => item.userId === userId,
          );

          console.log('refreshUserStatus called..', {
            index,
            responseStatus,
          });

          if (index >= 0) {
            let meetUser = responseStatus.data.meetUser;

            if (meetUser.micStatusCd === 1) {
              this.attendeeList[index]['rxAudioMute'] = false;
            } else {
              this.attendeeList[index]['rxAudioMute'] = true;
            }

            if (meetUser.camStatusCd === 1) {
              this.attendeeList[index]['rxVideoMute'] = false;
            } else {
              this.attendeeList[index]['rxVideoMute'] = true;
            }
          }
          this.loading = false;

          console.log('refreshUserStatus called..', {
            attendeeList: this.attendeeList,
          });
        } catch (error) {
          console.log(error);
          this.loadingDialog.dialog = false;
          this.loading = false;
        }
      }, 2000);
    },
    async disConnectCodec(callLegId) {
      // CMS
      let index = this.attendeeList.findIndex(
        (item) => item.callLegId === callLegId,
      );
      await this.$http
        .post(`/api/v1/meetings/disConnectUser/${callLegId}`, {
          params: JSON.stringify(this.attendeeList[index]),
        })
        .then((response) => {
          if (index >= 0) {
            this.attendeeList[index].callLegId = null;
            this.attendeeList[index].status = false;
          }
          console.log('disConnectUser called..', {
            attendeeList: this.attendeeList,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async disConnectUser(meetingKey, userId) {
      this.loading = true;
      let index = this.attendeeList.findIndex((item) => item.userId === userId);

      let params = {
        meetingKey,
        userId,
        isMCU: false,
      };
      await this.$http
        .post(`/api/v1/meetings/pcmobile/participants/leave/`, params)
        .then((response) => {
          console.log({ response });
          this.attendeeList[index].status = false;
          this.attendeeList[index].connLoading = false;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async sendMessage() {
      let params = {
        messageText: this.messageText,
        messageDuration: this.selectedMessageTime,
      };
      await this.$http
        .post(
          `/api/v1/meetings/send/message/${this.meetingInfo.callId}`,
          params,
        )
        .then((response) => {
          Util.snackBarOpen('공지사항 설정 완료.', 'green');
        })
        .catch((error) => {
          Util.snackBarOpen('공지사항 설정 에러.', 'red');
          console.log(error);
        });
    },
    async deleteMessage() {
      let params = {
        messageText: this.messageText,
        messageDuration: this.selectedMessageTime,
      };
      await this.$http
        .post(
          `/api/v1/meetings/delete/message/${this.meetingInfo.callId}`,
          params,
        )
        .then((response) => {
          Util.snackBarOpen('공지사항 설정 완료.', 'green');
        })
        .catch((error) => {
          Util.snackBarOpen('공지사항 설정 에러.', 'red');
          console.log(error);
        });
    },
    async setRecordStatus(value) {
      /**
       * value : true, false
       */
      let body = {
        recording: value,
        coSpaceId: this.meetingInfo.coSpaceId,
      };
      await this.$http
        .post(
          `/api/v1/meetings/setRecordStatus/${this.meetingInfo.callId}`,
          body,
        )
        .then((response) => {
          this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async setStreamingStatus(isLiveStreaming) {
      // 만약 사용자가 없는경우 스트리밍을 할 수 없습니다. ( 메시지 표시 )
      if (
        isLiveStreaming === true &&
        this.attendeeList.filter((item) => item.status === true).length <= 0
      ) {
        Util.snackBarOpen('참여자가 없으면 스트리밍을 할 수 없습니다.', 'pink');
        return;
      }

      this.loadingDialog.dialog = true;
      let body = {
        streaming: isLiveStreaming,
        callId: this.meetingInfo.callId,
        coSpaceId: this.meetingInfo.coSpaceId,
      };
      await this.$http
        .post(`/api/v1/meetings/liveStream`, body)
        .then((response) => {
          let data = response.data;
          if (data.allUse) {
            Util.snackBarOpen(
              '모든 Live streaming 주소가 사용중입니다.',
              'pink',
            );
            this.isStreaming = !isLiveStreaming;
          } else {
            this.isStreaming = isLiveStreaming;
          }
          this.loadingDialog.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.loadingDialog.dialog = false;
        });
    },
    async lockedCallClick() {
      if (this.call !== null) {
        this.loadingDialog.dialog = true;
        let body = {
          locked: this.call.call.locked === 'true' ? 'false' : 'true',
        };
        await this.$http
          .put(`/api/v1/meetings/locked/${this.meetingInfo.callId}`, body)
          .then((response) => {
            this.getCallStatus(this.meetingInfo.callId, this.meetingInfo._id);
            this.loadingDialog.dialog = false;
          })
          .catch((error) => {
            console.log(error);
            this.loadingDialog.dialog = false;
          });
      }
    },
    async fixLayoutClick() {
      console.log(`fixLayout`, 'open Laytout 고정 기능 팝업');
      this.fixLayout.dialog = true;
      // fixLayout
    },
    async applyLayoutAll() {
      this.warning.title = '전체 레이아웃';
      this.warning.content = `레이아웃을 변경 하시겠습니까?`;
      this.warning.confirmText = '확인';
      this.warning.type = 'layoutAll';
      this.warning.dialog = true;
    },
    async sendMessageConfirm() {
      this.warning.title = '공지사항 전달';
      this.warning.content = `공지를 전달하시겠습니까?`;
      this.warning.confirmText = '확인';
      this.warning.type = 'sendMessage';
      this.warning.dialog = true;
    },
    async layoutAllChange() {
      // all 은 layout
      await this.updateUserStatusAll({ layout: this.layoutAll });
    },
    async additionalInvite() {
      this.loadingDialog.dialog = true;

      await this.getRoomTree();
      // 화상회의인 경우 Device List 가져오기
      // await this.getPersonalDevice(); // 개인 단말 추가하는것 삭제하면서 주석처리
      // Get OriganizationTree Data
      // await this.getOrganizationTree();
      // Get People Data
      // await this.getPeopleData();

      this.addRoom.dialog = true;
      this.loadingDialog.dialog = false;
    },
    async getRoomTree() {
      // startTime, EndTime 계산
      let start = this.meetingInfo.startDtime; // moment.tz(this.meetingInfo.startDtime, this.meetingInfo.timeZone);
      let end = this.meetingInfo.endDtime; // moment.tz(this.meetingInfo.endDtime, this.meetingInfo.timeZone);
      // let now = moment.tz(moment().format('YYYY-MM-DD HH:mm'), this.meetingInfo.timeZone);
      let meetingType = this.meetingInfo.type === 0 ? 'room' : 'video';

      let params = { meetingType: meetingType, start: start, end: end };
      if (this.editMode) {
        params['_id'] = this.routerParams._id;
      }

      if (this.meetingInfo.type === 0) {
        params['type'] = 'room';
      } else {
        params['type'] = 'video';
      }

      if (this.meetingInfo.roomIds) {
        params['meetingId'] = this.meetingInfo._id;
      }

      params['email'] = this.$store.state.user.email;

      await this.$http
        .get('/api/v1/rooms/getRoomTreeAll', { params: params })
        .then((response) => {
          this.addRoom.roomItems = response.data;
          // this.roomItems = response.data;
          // console.log(this.roomItems);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getPersonalDevice() {
      let params = { meetingId: this.meetingInfo._id };

      await this.$http
        .get('/api/v1/devices/getPersonalDevice', { params: params })
        .then((response) => {
          this.addRoom.personalItems = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async refreshAll() {
      this.loadingDialog.dialog = true;
      this.initAttendees(this.meetingInfo);
      await this.getNowStatus(this.meetingInfo.meetingKey);
    },
    async dialAll() {
      // 먼저 새로고침 함.
      await this.refreshAll();
      // this.loadingDialog.dialog = true;
      // 현재 미참여 인 사람한테 모두 Call
      this.attendeeList
        .filter((item) => item.status === false)
        .forEach((item) => {
          // 한명씩 call 보냄()
          this.connectUser(item.remoteParty, item.name);
        });
      // this.loadingDialog.dialog = false;
    },
    async muteAll() {
      this.loadingDialog.dialog = true;
      let meetingKey = this.meetingInfo.meetingKey;
      let value = 0;
      let type = 2;
      await this.updateUserStatus(meetingKey, null, type, value);
      this.loadingDialog.dialog = false;
    },
    async unMuteAll() {
      this.loadingDialog.dialog = true;

      await this.updateUserStatusAll({ rxAudioMute: false });
      this.loadingDialog.dialog = false;
    },
    async finishMeeting() {
      // 경고 팝업 띄우기
      this.warning.title = '회의 종료';
      this.warning.content = `회의를 종료 하시겠습니까?`;
      this.warning.confirmText = '확인';
      this.warning.type = 'finishMeeting';
      this.warning.dialog = true;
    },
    async roomSave(selectedRooms, selectedAttendees) {
      this.loadingDialog.dialog = true;
      const alreadyInvitedPeople = selectedAttendees.filter((sa) =>
        this.meetingInfo.attendees.map((a) => a.email).includes(sa.email),
      );

      // 추가 초대 회의실, 참여자가 없으면 return;
      if (
        selectedRooms.length === 0 &&
        selectedAttendees.filter(
          (sa) =>
            !this.meetingInfo.attendees.map((a) => a.email).includes(sa.email),
        ).length === 0
      ) {
        this.addRoom.dialog = false;
        this.loadingDialog.dialog = false;
        return;
      }

      const params = {
        meetingId: this.meetingInfo._id,
        selectedRoomIds: selectedRooms.map((elem) => elem._id),
        selectedAttendeesEmail: selectedAttendees
          .filter(
            (sa) =>
              !this.meetingInfo.attendees
                .map((a) => a.email)
                .includes(sa.email),
          )
          .map((elem) => elem.email), // selectedAttendees.map(elem => elem.email)
      };
      // Add selectedRooms
      await this.$http
        .put('/api/v1/meetings/additionalInvite', params)
        .then((response) => {
          if (typeof response.data === 'object') {
            this.addRoom.dialog = false;
            this.meetingInfo = response.data;
            this.refreshAll();
          } else {
            this.loadingDialog.dialog = false;
            Util.snackBarOpen(
              this.$t('page.meeting-control.invitation-fail-msg'),
              'pink',
            );
          }
          this.loadingDialog.dialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async closeWarningDialog(ret) {
      console.log(`closeWarningDialog`, ret);
      if (ret === 'ok') {
        if (this.warning.type === 'finishMeeting') {
          this.warning.dialog = false;
          // 종료
          await this.$http
            .post(`/api/v1/meetings/finishMeeting/${this.meetingInfo._id}`)
            .then((response) => {
              console.log('closeWarningDialog called..', { response });
              if (response.data.success === true) {
                this.closeDialog('pcmobile');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (this.warning.type === 'layoutAll') {
          this.layoutAllChange();
          this.warning.dialog = false;
        } else if (this.warning.type === 'sendMessage') {
          this.sendMessage();
          this.warning.dialog = false;
        }
      } else {
        this.warning.dialog = false;
      }
    },
    // async closeWarningDialog(ret) {
    //   console.log(`closeWarningDialog`, ret);
    //   if (ret === 'ok') {
    //     if (this.warning.type === 'finishMeeting') {
    //       this.warning.dialog = false;
    //       // 종료
    //       await this.$http
    //         .post(`/api/v1/meetings/finishMeeting/${this.meetingInfo._id}`)
    //         .then((response) => {
    //           if (response.data.success === true) {
    //             this.closeDialog('control');
    //           }
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //         });
    //     } else if (this.warning.type === 'layoutAll') {
    //       this.layoutAllChange();
    //       this.warning.dialog = false;
    //     } else if (this.warning.type === 'sendMessage') {
    //       this.sendMessage();
    //       this.warning.dialog = false;
    //     }
    //   } else {
    //     this.warning.dialog = false;
    //   }
    // },
    closeRoomDialog() {
      this.addRoom.dialog = false;
    },
    closeLayoutDialog() {
      this.fixLayout.dialog = false;
    },
    async getOrganizationTree() {
      let params = {
        meetingId: this.meetingInfo._id,
      };
      await this.$http
        .get('/api/v1/organizations/trees', { params: params })
        .then((response) => {
          this.addAttendee.organizationItems = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getPeopleData() {
      let params = {
        meetingId: this.meetingInfo._id,
      };
      await this.$http
        .get('/api/v1/organizations/filtered', { params: params })
        .then((response) => {
          this.addAttendee.people = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async attendeeDetailClick(item) {
      this.loadingDialog.dialog = true;
      // get Attendee Detail Info;
      await this.$http
        .get(`/api/v1/meetings/getNowStatusDetail/${item.callLegId}`, {
          params: {
            serverIdx: item.serverIdx,
            callId: this.meetingInfo.callId,
          },
        })
        .then((response) => {
          this.attendeeDetail.attendeeInfo = item;
          this.attendeeDetail.attendeeDetailInfo = response.data.callLeg;
          this.attendeeDetail.dialog = true;
          this.loadingDialog.dialog = false;
        })
        .catch((error) => {
          this.loadingDialog.dialog = false;
          console.log(error);
        });
    },
    async layoutChange(callLegId, layout) {
      // serverIdx 찾기
      let selectedCallLeg = this.attendeeList.find(
        (a) => a.callLegId === callLegId,
      );
      let serverIdx = selectedCallLeg ? selectedCallLeg.serverIdx : 1;
      // 개별 변경은 chosenLayout
      await this.updateUserStatus(callLegId, {
        chosenLayout: layout,
        callId: this.meetingInfo.callId,
        serverIdx: serverIdx,
      });
    },
    closeDetailDialog() {
      this.attendeeDetail.dialog = false;
    },
    async refreshDetailData(callLegId) {
      // serverIdx 찾기
      let selectedCallLeg = this.attendeeList.find(
        (a) => a.callLegId === callLegId,
      );
      let serverIdx = selectedCallLeg ? selectedCallLeg.serverIdx : 1;
      await this.$http
        .get(`/api/v1/meetings/getNowStatusDetail/${callLegId}`, {
          params: { serverIdx: serverIdx, callId: this.meetingInfo.callId },
        })
        .then((response) => {
          this.attendeeDetail.attendeeDetailInfo = response.data.callLeg;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    popupClose() {
      this.loadingDialog.dialog = false;
      this.closeDialog('pcmobile');
    },
    getTypeString(participantType, type) {
      if (participantType === 'skype') {
        // Skype 참여 인 경우
        return 'PC/Mobile';
      } else if (participantType === 'webex' || type === 'webex') {
        // Webex 참여 인 경우
        return this.$t('page.statistics.history.webex');
      } else if (participantType === 'webrtc') {
        // WebRTC 참여 인 경우
        return 'WebRTC';
      } else if (participantType === 'codec') {
        // Codec 참여 인 경우
        return this.$t('page.statistics.history.codec');
      } else if (!participantType && type === 'device') {
        // codec인데 참여 안 한경우
        return this.$t('page.statistics.history.codec');
      } else {
        // 초대자인데 참여 안 한경우
        return '';
      }
    },
  },
};
</script>
<style scoped>
/* MeetingControlDialog */
.title-wrap {
  float: left;
  font-weight: 300;
  font-size: 15px;
  margin-right: 30px;
  margin-left: 10px;
}
.contents-wrap {
  float: left;
  font-weight: 100;
  font-size: 15px;
}

.title-wrap div {
  height: 25px;
}

.contents-wrap div {
  height: 25px;
}

.v-card {
  box-shadow: none;
}

.meeting-control-btn {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  font-weight: 300;
  text-align: center;
  line-height: 38px;
  background: #6264a7;
  cursor: pointer;
  color: white;
  float: left;
  margin-right: 10px;
}

.meeting-control-btn:hover {
  opacity: 0.8;
}

.header-text-popup {
  background: white;
}

.v-card__text {
  padding-top: 5px;
}

input {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/MeetingControlPCMobileOnlyDialog.vue